<template>
  <div>
    <el-card class="ibox">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('couponShopPoolDetail.queryCondition') }}</div>
      </div>
      <div class="">
        <el-form :inline="true" :model="couponShopPoolDetailInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-form-item>
              <el-input
                v-model="couponShopPoolDetailInfo.conditions.couponName"
                :placeholder="$t('couponShopPoolDetail.enterCoupon')"
                clearable
              />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-date-picker
                v-model="couponShopPoolDetailInfo.conditions.createTime"
                type="daterange"
                :placeholder="$t('couponShopPoolDetail.selectPurchaseTime')"
                style="width: 100%"
              />
            </el-form-item>
          </el-form-item>
          <el-form-item>
              <el-input
                v-model="couponShopPoolDetailInfo.conditions.userName"
                :placeholder="$t('couponShopPoolDetail.enterMemberName')"
                clearable
              />
          </el-form-item>
          <el-form-item>
            <el-form-item>
              <el-input
                v-model="couponShopPoolDetailInfo.conditions.tel"
                :placeholder="$t('couponShopPoolDetail.enterPhone')"
                clearable
              />
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="_queryCouponDetailMethod"
            >
              <i class="el-icon-search"></i>
              {{ $t('common.query') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="flex justify-between">
        <div>{{ $t('couponShopPoolDetail.shopPurchaseRecord') }}</div>
      </div>
      <div class="">
        <coupon-shop-pool-detail-table
          :table-data="couponShopPoolDetailInfo.couponShopPoolDetails"
          @edit="_openEditCouponDetailModel"
          @delete="_openDeleteCouponDetailModel"
        />
        
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="couponShopPoolDetailInfo.total"
          :page-size="pageSize"
          :current-page="currentPage"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import { listCouponShopPoolDetail } from '@/api/goods/couponShopPoolDetailApi'
import { getShopId } from '@/api/shop/shopApi'
import CouponShopPoolDetailTable from '@/components/goods/CouponShopPoolDetailTable'

export default {
  name: 'CouponShopPoolDetailManage',
  components: {
    CouponShopPoolDetailTable
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      couponShopPoolDetailInfo: {
        couponShopPoolDetails: [],
        total: 0,
        conditions: {
          couponName: '',
          userName: '',
          tel: '',
          createTime: '',
          shopId: getShopId()
        }
      }
    }
  },
  created() {
    this._listcouponShopPoolDetails()
  },
  methods: {
    async _listcouponShopPoolDetails() {
      const params = {
        ...this.couponShopPoolDetailInfo.conditions,
        page: this.currentPage,
        row: this.pageSize
      }
      
      try {
        const res = await listCouponShopPoolDetail(params)
        this.couponShopPoolDetailInfo.couponShopPoolDetails = res.data
        this.couponShopPoolDetailInfo.total = res.total
      } catch (error) {
        console.error('获取数据失败:', error)
      }
    },
    _queryCouponDetailMethod() {
      this.currentPage = 1
      this._listcouponShopPoolDetails()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this._listcouponShopPoolDetails()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listcouponShopPoolDetails()
    },
    _openEditCouponDetailModel(row) {
      console.log(row)
      this.$refs.editDialog.open(row)
    },
    _openDeleteCouponDetailModel(row) {
      console.log(row)
      this.$refs.deleteDialog.open(row)
    }
  }
}
</script>

<style scoped>
.ibox {
  margin-bottom: 20px;
}
.ibox-title {
  border-bottom: 1px solid #e7eaec;
  padding: 15px 15px 7px;
}
.ibox-content {
  padding: 15px;
}
</style>